module.exports = __webpack_public_path__ + "media/images/online/online-wedding-in-this-price-image-3-ae01d2c1e20eb0865dff09c722d31f55.png";